<script lang="ts">
    import { tweened } from 'svelte/motion';
    import { cubicOut } from 'svelte/easing';

    export let label: string = '';
    export let currentValue: number | null = null;
    export let totalValue: number | null = null;
    export let color: string = '#4b4b4b';
    export let displayMode: 'simple' | 'detailed' = 'detailed';

    let percentage: number | null = null;

    const percentageTweened = tweened(0, {
        duration: 900,
        easing: cubicOut,
    });

    const currentValueTweened = tweened(0, {
        duration: 900,
        easing: cubicOut,
    });

    $: if (currentValue !== null && totalValue !== null && totalValue > 0) {
        percentage = (currentValue / totalValue) * 100;
        percentageTweened.set(percentage);
        currentValueTweened.set(currentValue);
    }
</script>

<div class="container">
    <div class="progress-bar-label dont-break" style="color: {color}">{label}</div>
    <div class="progress-bar-container" style={percentage === null ? 'filter: grayscale(1)' : ''}>
        <div class="background"></div>
        <div
            class="foreground"
            style="width:{percentage !== null && percentage > 0
                ? Math.min(Math.max($percentageTweened, 5), 100)
                : 0}%; background-color: {color};"
        ></div>
    </div>
    {#if displayMode === 'detailed'}
        <div class="progress-bar-footer">
            <div class="progress-bar-percent" style="color: {color}">
                {percentage !== null ? Math.floor($percentageTweened) + '%' : ''}
            </div>
            <div class="progress-bar-values">
                <div class="progress-bar-value" style="color: {color}">
                    {currentValue !== null ? Math.round($currentValueTweened) : '-'}
                </div>
                <div>/</div>
                <div class="progress-bar-total">{totalValue !== null ? totalValue : '-'}</div>
            </div>
        </div>
    {/if}
</div>

<style>
    :root {
        --barHeightLight: 2px;
        --radiusLight: 1px;
        --barBackgroundAnalytics: #f0f0f0;
        /*--barForegroundAnalytics: #f4e1a6;*/
    }
    .container {
        margin: 0;
        /*color: var(--barForegroundAnalytics);*/
        display: flex;
        flex-direction: column;
        min-width: 40px;
    }
    .progress-bar-footer {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
    }
    .progress-bar-values {
        display: flex;
        align-items: flex-end;
        column-gap: 5px;
        color: #ccc;
        font-size: 10px;
    }
    .progress-bar-percent,
    .progress-bar-value {
        font-weight: bold;
        /*color: var(--barForegroundAnalytics);*/
        font-size: 13px;
        line-height: 15px;
    }
    .progress-bar-label {
        font-size: 15px;
    }
    .progress-bar-container {
        width: 100%;
        margin: 2px 0;
        position: relative;
    }
    .background {
        width: 100%;
        /*height: var(--barHeightLight);*/
        height: 3px;
        background-color: var(--barBackgroundAnalytics);
        /*border-radius: var(--radiusLight);*/
        border-radius: 1px;
    }
    .foreground {
        top: 0;
        position: absolute;
        width: 100%;
        /*height: var(--barHeightLight);*/
        height: 3px;
        /*background-color: var(--barForegroundAnalytics);*/
        border-radius: 1px; /*var(--radiusLight);*/
    }
</style>
